import { createTheme } from '@mui/material/styles';

/**
 * Public-site typography scale.
 * H1 = page heroes, H2 = section titles, H3 = card/subsection titles.
 * Weights stay within loaded Montserrat faces (400 / 600 / 700).
 */
export const publicTheme = createTheme({
  palette: {
    primary: {
      main: '#35bcb3',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.25rem',
      lineHeight: 1.2,
      letterSpacing: '-0.02em',
      marginBottom: 0,
      '@media (min-width:600px)': {
        fontSize: '2.75rem',
      },
      '@media (min-width:900px)': {
        fontSize: '3rem',
      },
    },
    h2: {
      fontWeight: 700,
      fontSize: '1.5rem',
      lineHeight: 1.3,
      letterSpacing: '-0.02em',
      marginBottom: 0,
      '@media (min-width:900px)': {
        fontSize: '2.125rem',
      },
    },
    h3: {
      fontWeight: 700,
      fontSize: '1.125rem',
      lineHeight: 1.4,
      letterSpacing: '-0.01em',
      marginBottom: 0,
      '@media (min-width:900px)': {
        fontSize: '1.25rem',
      },
    },
    h4: {
      fontWeight: 700,
      fontSize: '1.0625rem',
      lineHeight: 1.4,
      letterSpacing: '-0.01em',
      marginBottom: 0,
      '@media (min-width:900px)': {
        fontSize: '1.175rem',
      },
    },
    h5: {
      fontWeight: 600,
      fontSize: '1rem',
      lineHeight: 1.45,
      marginBottom: 0,
      '@media (min-width:900px)': {
        fontSize: '1.0625rem',
      },
    },
    h6: {
      fontWeight: 600,
      fontSize: '0.9375rem',
      lineHeight: 1.45,
      marginBottom: 0,
    },
    subtitle1: {
      fontWeight: 600,
      fontSize: '1.0625rem',
      lineHeight: 1.55,
    },
    subtitle2: {
      fontWeight: 600,
      fontSize: '0.875rem',
      lineHeight: 1.55,
    },
    body1: {
      fontWeight: 400,
      fontSize: '1rem',
      lineHeight: 1.7,
      '@media (min-width:900px)': {
        fontSize: '1.0625rem',
      },
    },
    body2: {
      fontWeight: 400,
      fontSize: '0.875rem',
      lineHeight: 1.7,
    },
    button: {
      fontWeight: 600,
      textTransform: 'none',
    },
    caption: {
      fontWeight: 500,
      fontSize: '0.75rem',
      lineHeight: 1.5,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#35bcb3',
          '&:hover': {
            color: '#2aa899',
          },
        },
      },
    },
    MuiTypography: {
      defaultProps: {
        variantMapping: {
          h1: 'h1',
          h2: 'h2',
          h3: 'h3',
          h4: 'h4',
          h5: 'h5',
          h6: 'h6',
        },
      },
    },
  },
});
